import { render } from "./Profile.vue?vue&type=template&id=74288990"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/kingdomIn/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74288990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74288990', __exports__)) {
    api.reload('74288990', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=74288990", () => {
    api.rerender('74288990', render)
  })

}


export default __exports__